import type { Identity } from "@core/domains/identity";

export function identityLabel(identities: readonly Identity[]): string {
  return identities.map(formatIdentity).join(", ");
}

function formatIdentity(identity: Identity): string {
  switch (identity.identifierType) {
    case "email":
      return identity.identifier;
    case "service":
      return `${identity.identifierType}:${identity.identifier}`;
  }
}
